import {
  LISTING_STATE_CLOSED,
  LISTING_STATE_DRAFT,
  LISTING_STATE_PUBLISHED,
} from '../../util/types';

export const MY_LISTINGS_FILTER = {
  ALL: 'all',
  ACTIVE: 'active',
  DRAFT: 'draft',
  TRASH: 'trash',
};

const getListingState = listing => listing?.attributes?.state;

export const isActiveListing = listing => getListingState(listing) === LISTING_STATE_PUBLISHED;

export const isDraftListing = listing => getListingState(listing) === LISTING_STATE_DRAFT;

export const isTrashedListing = listing => {
  const trash = listing?.attributes?.privateData?.trash;
  return !!trash && typeof trash === 'object';
};

export const isClosedListing = listing => getListingState(listing) === LISTING_STATE_CLOSED;

/** Own listings that can appear in the linked-listings / package picker. */
export const isLinkableOwnListing = listing =>
  !!listing && !isTrashedListing(listing) && !isClosedListing(listing);

export const getMyListingsStatusCounts = listings => {
  const safeListings = listings || [];
  const nonTrashed = safeListings.filter(l => !isTrashedListing(l));

  return {
    [MY_LISTINGS_FILTER.ALL]: nonTrashed.length,
    [MY_LISTINGS_FILTER.ACTIVE]: nonTrashed.filter(isActiveListing).length,
    [MY_LISTINGS_FILTER.DRAFT]: nonTrashed.filter(isDraftListing).length,
    [MY_LISTINGS_FILTER.TRASH]: safeListings.filter(isTrashedListing).length,
  };
};

export const filterMyListingsByStatus = (listings, status) => {
  const safeListings = listings || [];

  if (status === MY_LISTINGS_FILTER.TRASH) {
    return safeListings.filter(isTrashedListing);
  }

  const nonTrashed = safeListings.filter(l => !isTrashedListing(l));

  if (status === MY_LISTINGS_FILTER.DRAFT) {
    return nonTrashed.filter(isDraftListing);
  }

  if (status === MY_LISTINGS_FILTER.ACTIVE) {
    return nonTrashed.filter(isActiveListing);
  }

  return nonTrashed;
};
